<template>
    <div class="p-3 w-100">
        <b-alert show variant="danger">{{ $t(`errors.${this.code}`) }}</b-alert>
    </div>
</template>

<script>
export default {
    name: 'Error',
    props: {
        code: String
    }
}
</script>
